import * as THREE from 'three'
import Experience from '../Experience';
import gsap from 'gsap'

export default class CatManager {

    constructor(pWorkdenSceneRef)
    {
        this.experienceRef = new Experience();
        this.webGLsceneRef = this.experienceRef.threeJSscene;
        this.timeRef = this.experienceRef.time;
        this.resourcesRef = this.experienceRef.resources;        
        this.workdenSceneRef = pWorkdenSceneRef;
        this.catTreeLevel5 = this.workdenSceneRef.catTreePositionMarker01;
        this.catTreeLevel3 = this.workdenSceneRef.catTreePositionMarker02;
        this.materialsRef = this.experienceRef.materials;
        this.cameraRef = null;
        this.instantiateCatsBehaviors();
        this.catMimiClickCounter = 0;
        this.timeSinceCatMimiIsIdle = 0;
        this.catMimiPatienceTime = 10;
    }

    instantiateCatsBehaviors()
    {     
        //Mimi   
        this.setupMimi();
        //Cindy
        this.setupCindy();
        
        this.clock = new THREE.Clock()
        this.previousTime = 0        
        
        // ONLY Debugging and Testing
        //this.setKeyboardControls();
        //this.createInvisibleBoundingBox();

        this.createSleepAuraParticleEffect();
    }

    setupMimi()
    {
        //Mimi   
        this.catTreeLevel5GlobalPosition = new THREE.Vector3();
        this.catTreeLevel5.getWorldPosition(this.catTreeLevel5GlobalPosition);
        this.workdenSceneRef.catMimi.position.copy(this.catTreeLevel5GlobalPosition);
        this.workdenSceneRef.catMimi.rotateY(Math.PI);
        this.animationMixer_Mimi = new THREE.AnimationMixer(this.workdenSceneRef.catMimi);        
        
        this.animationActionsMap_Mimi = new Map();        

        if (this.workdenSceneRef.catRigAndModel.animations && this.workdenSceneRef.catRigAndModel.animations.length > 0) 
        {
            //console.log(`Found ${this.workdenSceneRef.catRigAndModel.animations.length} animation clips:`);
            
            // Loop through all animation clips and print their names
            this.workdenSceneRef.catRigAndModel.animations.forEach((clip, index) => 
            {
                //console.log(`${index + 1}. ${clip.name || 'Unnamed clip'}`);

                const action = this.animationMixer_Mimi.clipAction(clip);
                this.animationActionsMap_Mimi.set(clip.name, action);
            });
        }
        
        // Initial Sleeping Animation
        this.currentAction_Mimi = this.animationActionsMap_Mimi.get("Rest_Sleep_Idle");
        this.currentAction_Mimi.setLoop(THREE.LoopPingPong);
        this.currentAction_Mimi.setEffectiveWeight(1);
        this.currentAction_Mimi.reset();
        this.currentAction_Mimi.play();

        this.currentCatMimiState = "Sleeping";

        this.animationMixer_Mimi.addEventListener('finished', (event) => {

            // event.action is the action that finished
            if (event.action._clip.name === 'Rest_Sleep_From')
            {                
                // Play Loop
                this.fadeToAction("Rest_Lie_Idle", true, false);
                this.currentCatMimiState = "Sitting"
                return;
            }

            if (event.action._clip.name === 'Rest_Lie_From')
            {
                // Play Loop                
                this.fadeToAction("Idle", true, false);
                this.currentCatMimiState = "Standing"
                return;
            }

            if (event.action._clip.name === 'Rest_Lie_To')
            {
                // Play Loop                
                this.fadeToAction("Rest_Lie_Idle", true, false);
                this.currentCatMimiState = "Sitting"
                return;
            }

        });
        
    }

    setupCindy()
    {
        //Cindy  
        var globalPosition = new THREE.Vector3();
        this.catTreeLevel3.getWorldPosition(globalPosition);        
        this.workdenSceneRef.catCindy.position.copy(globalPosition);
        this.workdenSceneRef.catCindy.rotateY(Math.PI);
        this.animationMixer_Cindy = new THREE.AnimationMixer(this.workdenSceneRef.catCindy);        
        
        this.animationActionsMap_Cindy = new Map();        

        if (this.workdenSceneRef.catRigAndModel.animations && this.workdenSceneRef.catRigAndModel.animations.length > 0) 
        {
            //console.log(`Found ${this.workdenSceneRef.catRigAndModel.animations.length} animation clips:`);
            
            // Loop through all animation clips and print their names
            this.workdenSceneRef.catRigAndModel.animations.forEach((clip, index) => 
            {
                //console.log(`${index + 1}. ${clip.name || 'Unnamed clip'}`);

                const action = this.animationMixer_Cindy.clipAction(clip);
                this.animationActionsMap_Cindy.set(clip.name, action);
            });
        }
        
        this.currentAction_Cindy = this.animationActionsMap_Cindy.get("Rest_Lie_Idle");
        this.currentAction_Cindy.setLoop(THREE.LoopPingPong);
        this.currentAction_Cindy.setEffectiveWeight(1);
        this.currentAction_Cindy.reset();
        this.currentAction_Cindy.play();
    }

    onCatMimiClicked()
    {
        // ON every click for Cat Mimi
        this.changeCatMimiAnimationState(true);        
        this.timeSinceCatMimiIsIdle = 0;
        this.catMimiClickCounter++;
    }

    changeCatMimiAnimationState(isUserRequested = false)
    {
        if (this.currentCatMimiState === "Sleeping" && isUserRequested)
        {
            this.playRandomSFX();
            this.currentCatMimiState = "WakingUp"
            // Play Once
            this.fadeToAction("Rest_Sleep_From", false, true);
            this.sleepAuraParticles.visible = false;
            return;
        }

        if (this.currentCatMimiState === "Sitting" && isUserRequested)
        {
            this.currentCatMimiState = "StandingUp"
            // Play Once
            this.fadeToAction("Rest_Lie_From", false, true);
            gsap.to(this.workdenSceneRef.catMimi.position, {
                duration: 1,
                ease: "power1.inOut",
                x: this.workdenSceneRef.catMimi.position.x - 300,
                y: this.workdenSceneRef.catMimi.position.y,
                z: this.workdenSceneRef.catMimi.position.z - 200
            });
            return;
        }

        // Cat sits down after being Idle for more than Patience Time limit
        if (this.currentCatMimiState === "Standing" && !isUserRequested)
        {
            this.currentCatMimiState === "SittingDown";
            // Play Once
            this.fadeToAction("Rest_Lie_To", false, true);            
            gsap.to(this.workdenSceneRef.catMimi.position, 
            {
                duration: 0.7,
                ease: "power1.inOut",
                x: this.catTreeLevel5GlobalPosition.x,
                y: this.catTreeLevel5GlobalPosition.y,
                z: this.catTreeLevel5GlobalPosition.z
            });            
            return;
        }

        // Cat sleeps after being Idle for more than Patience Time limit
        if (this.currentCatMimiState === "Sitting" && !isUserRequested)
        {
            // Play Once
            this.fadeToAction("Rest_Sleep_Idle", true, false);            
            this.currentCatMimiState = "Sleeping"
            return;
        }
    }

    // Simple crossfade transition
    fadeToAction(name, isLooping, clampAtEnd, duration = 0.5)
    {
        this.previousAction = this.currentAction_Mimi;
        this.currentAction_Mimi = this.animationActionsMap_Mimi.get(name);
        
        if (this.previousAction !== this.currentAction_Mimi)
        {

            if (isLooping)
            {
                this.currentAction_Mimi.setLoop(THREE.LoopRepeat)
            }
            else
            {
                this.currentAction_Mimi.setLoop(THREE.LoopOnce)
            }

            // Configure the new action
            this.currentAction_Mimi.reset()
                .setEffectiveTimeScale(1)
                .setEffectiveWeight(1)                
                .fadeIn(duration)
                .play();

            this.currentAction_Mimi.clampWhenFinished  = clampAtEnd        // Hold the last frame

            // Fade out the previous action
            if (this.previousAction) 
            {
                this.previousAction.fadeOut(duration);
            }
        }
    }

    update()
    {
        const elapsedTime = this.clock.getElapsedTime()
        const deltaTime = elapsedTime - this.previousTime
        this.previousTime = elapsedTime
        this.timeSinceCatMimiIsIdle += deltaTime;

        //Update Animation Mixer to play the animation every frame
        if (this.animationMixer_Mimi != null)
            this.animationMixer_Mimi.update(deltaTime);
        if (this.animationMixer_Cindy != null)
            this.animationMixer_Cindy.update(deltaTime);


        // Move sleep aura particles and fade when Cat Mimi is sleeping
        if (this.sleepAuraParticles && this.currentCatMimiState === "Sleeping")
        {
            for (let i = 0; i < this.sleepAuraParticleCount; i++) 
            {
                this.sleepAuraParticleAges[i] += deltaTime;
            
                // move upward
                this.sleepAuraParticlePositions[i * 3 + 1] += 30 * deltaTime;
            
                // fade out
                this.sleepAuraParticleAlphas[i] = 1.0 - (this.sleepAuraParticleAges[i] / this.sleepAuraParticleLifecycle);
            
                if (this.sleepAuraParticleAges[i] >= this.sleepAuraParticleLifecycle)
                {
                  this.resetSleepAuraParticles(i);
                }
            }
            
            this.sleepAuraParticleGeometry.attributes.position.needsUpdate = true;
            this.sleepAuraParticleGeometry.attributes.customAlpha.needsUpdate = true;
        }

        if (!this.cameraRef)
        {
            // Since Audio Listener requires an active Camera in the scene
            this.cameraRef = this.experienceRef.camera;
            this.setupCatSounds();
        }

        // Change Cat Mimi state after a certain seconds of inactivity
        if (this.currentCatMimiState === "Standing" && this.timeSinceCatMimiIsIdle > this.catMimiPatienceTime)  //seconds
        {
            this.changeCatMimiAnimationState();
            this.timeSinceCatMimiIsIdle = 0;
        }

        // Change Cat Mimi state to Sleeping after a certain seconds of inactivity
        if (this.currentCatMimiState === "Sitting" && this.timeSinceCatMimiIsIdle > this.catMimiPatienceTime)  //seconds
        {
            this.changeCatMimiAnimationState();
            this.timeSinceCatMimiIsIdle = 0;
            this.sleepAuraParticles.visible = true;
        }
    }

    createInvisibleBoundingBox() 
    {
        // Calculate bounding box from the model
        //const box = new THREE.Box3().setFromObject(this.workdenSceneRef.catRig.scene);

        const box = new THREE.Box3();
        // Calculate bounding box from the model
        this.workdenSceneRef.catRig.scene.traverse((child) => {
            if (child.isMesh) {
                // Update the mesh's matrix world
                child.updateMatrixWorld(true);
                
                // Expand the box to include this mesh
                const meshBox = new THREE.Box3().setFromObject(child);
                box.union(meshBox);
            }
        });

        const size = box.getSize(new THREE.Vector3());
        const center = box.getCenter(new THREE.Vector3());
        
        // Create invisible box geometry
        const boxGeometry = new THREE.BoxGeometry(size.x, size.y, size.z);
        const boxMaterial = new THREE.MeshBasicMaterial({ 
            color: 0xffff00,        // Yellow color
            wireframe: true,        // Wireframe mode                        
            depthTest: false
        });
        
        // Create the invisible mesh
        const invisibleBox = new THREE.Mesh(boxGeometry, boxMaterial);
        invisibleBox.position.copy(center);
        invisibleBox.name = 'invisibleBoundingBox'; // For identification
        this.webGLsceneRef.add(invisibleBox);
        
        //Create Box3Helper to visualize the bounds
        //this.boxHelper = new THREE.Box3Helper(box, 0xff0000);
        //this.webGLsceneRef.add(this.boxHelper);
    }

    setKeyboardControls()
    {
        window.addEventListener( 'keydown', (event) =>
            {
                if(event.code === 'KeyQ')
                {
                    console.log(event.code);            
                }
            
                if(event.code === 'Digit1')
                {
                    console.log(event.code);                    
                    if (this.currentAction_Mimi) 
                    {   
                        this.currentAction_Mimi.stop();
                        this.currentAction_Mimi.setEffectiveWeight(0);    
                    }
                    this.currentAction_Mimi = this.animationActionsMap_Mimi.get("Idle");
                    this.currentAction_Mimi.reset() // Reset animation to start
                    this.currentAction_Mimi.setEffectiveWeight(1) // Full weight
                    this.currentAction_Mimi.setLoop(THREE.LoopPingPong)                               
                    this.currentAction_Mimi.play();
                }
            
                if(event.code === 'Digit2')
                {                    
                    console.log(event.code);                    
                    if (this.currentAction_Mimi) 
                    {   
                        this.currentAction_Mimi.stop();
                        this.currentAction_Mimi.setEffectiveWeight(0);    
                    }
                    this.currentAction_Mimi = this.animationActionsMap_Mimi.get("Rest_Lie_To");
                    this.currentAction_Mimi.reset() // Reset animation to start
                    this.currentAction_Mimi.setEffectiveWeight(1) // Full weight
                    this.currentAction_Mimi.setLoop(THREE.LoopPingPong)                               
                    this.currentAction_Mimi.play();
                }

                if(event.code === 'Digit3')
                {                    
                    console.log(event.code);                    
                    if (this.currentAction_Mimi) 
                    {   
                        this.currentAction_Mimi.stop();
                        this.currentAction_Mimi.setEffectiveWeight(0);    
                    }
                    this.currentAction_Mimi = this.animationActionsMap_Mimi.get("Rest_Lie_Idle");
                    this.currentAction_Mimi.reset() // Reset animation to start
                    this.currentAction_Mimi.setEffectiveWeight(1) // Full weight
                    this.currentAction_Mimi.setLoop(THREE.LoopPingPong)                               
                    this.currentAction_Mimi.play(); 
                }

                if(event.code === 'Digit4')
                {
                    console.log(event.code);                    
                    if (this.currentAction_Mimi) 
                    {   
                        this.currentAction_Mimi.stop();
                        this.currentAction_Mimi.setEffectiveWeight(0);    
                    }
                    this.currentAction_Mimi = this.animationActionsMap_Mimi.get("Rest_Lie_From");
                    this.currentAction_Mimi.reset() // Reset animation to start
                    this.currentAction_Mimi.setEffectiveWeight(1) // Full weight
                    this.currentAction_Mimi.setLoop(THREE.LoopPingPong)                               
                    this.currentAction_Mimi.play();              
                }

                if(event.code === 'Digit5')
                {                    
                    console.log(event.code);                    
                    if (this.currentAction_Mimi) 
                    {   
                        this.currentAction_Mimi.stop();
                        this.currentAction_Mimi.setEffectiveWeight(0);    
                    }
                    this.currentAction_Mimi = this.animationActionsMap_Mimi.get("Rest_Sleep_Idle");
                    this.currentAction_Mimi.reset() // Reset animation to start
                    this.currentAction_Mimi.setEffectiveWeight(1) // Full weight
                    this.currentAction_Mimi.setLoop(THREE.LoopPingPong)                               
                    this.currentAction_Mimi.play();              
                }
            })   
    }

    createSleepAuraParticleEffect()
    {
        //Get Cat's global position
        this.worldCatMimiPosition = new THREE.Vector3();
        this.workdenSceneRef.catMimi.getWorldPosition(this.worldCatMimiPosition);

        // Create 10 particles
        this.sleepAuraParticleCount = 5;
        this.sleepAuraParticlesSpawnAreaRadius = 400;
        this.sleepAuraParticlesSpawnAreaHeight = 200;
        this.sleepAuraParticleLifecycle = 5; //5 seconds

        this.sleepAuraParticlePositions = new Float32Array(this.sleepAuraParticleCount * 3); // x, y, z for each particle
        this.sleepAuraParticleAlphas = new Float32Array(this.sleepAuraParticleCount);
        this.sleepAuraParticleAges = new Float32Array(this.sleepAuraParticleCount);
        this.sleepAuraParticleGeometry = new THREE.BufferGeometry();        

        // Randomly place particles inside a cylinder
        this.resetSleepAuraParticles();

        this.sleepAuraParticleGeometry.setAttribute('position', new THREE.BufferAttribute(this.sleepAuraParticlePositions, 3));
        this.sleepAuraParticleGeometry.setAttribute('customAlpha', new THREE.BufferAttribute(this.sleepAuraParticleAlphas, 1));

        // Create Points objects
        this.sleepAuraParticles = new THREE.Points(this.sleepAuraParticleGeometry, this.materialsRef.sleepAuraParticleMaterial);
        this.webGLsceneRef.add(this.sleepAuraParticles);
    }

    createAlertingEmojiParticleEffect()
    {
        // Create 10 particles
        this.alertEmojiParticleCount = 1;        
        this.alertEmojiParticleLifecycle = 3; //3 seconds

        this.alertEmojiParticlePosition = new Float32Array(this.alertEmojiParticleCount * 3); // x, y, z for each particle
        this.alertEmojiParticleAlphas = new Float32Array(this.sleepAuraParticleCount);
        this.sleepAuraParticleAges = new Float32Array(this.sleepAuraParticleCount);
        
        this.alertEmojiParticleGeometry = new THREE.BufferGeometry();
        this.alertEmojiParticleGeometry.setAttribute(
            'position',
            new THREE.Float32BufferAttribute([
                this.worldCatMimiPosition.x - 400,
                this.worldCatMimiPosition.y + 400,
                this.worldCatMimiPosition.z - 100
            ], 3)
        );   
    }

    resetSleepAuraParticles()
    {
        // Randomly place particles inside a cylinder
        for (let i = 0; i < this.sleepAuraParticleCount; i++)
        {
            const theta = Math.random() * 2 * Math.PI; // angle around Y axis
            const r = Math.random() * this.sleepAuraParticlesSpawnAreaRadius;         // distance from center
            const y = (Math.random() - 0.5) * this.sleepAuraParticlesSpawnAreaHeight; // y position within cylinder height

            const x = r * Math.cos(theta);
            const z = r * Math.sin(theta);

            this.sleepAuraParticlePositions[i * 3] = x;
            this.sleepAuraParticlePositions[i * 3 + 1] = y;
            this.sleepAuraParticlePositions[i * 3 + 2] = z;

            // Add Cat position offset
            this.sleepAuraParticlePositions[i * 3] += this.worldCatMimiPosition.x - 400;
            this.sleepAuraParticlePositions[i * 3 + 1] += this.worldCatMimiPosition.y + 400;
            this.sleepAuraParticlePositions[i * 3 + 2] += this.worldCatMimiPosition.z - 100;

            this.sleepAuraParticleAges[i] = 0;
            this.sleepAuraParticleAlphas[i] = 1;
        }
        
    }

    setupCatSounds()
    {
        this.cameraRef = this.experienceRef.camera.cameraInstance;

        // Create listener and add to camera
        this.catSoundsListener = new THREE.AudioListener();
        this.cameraRef.add(this.catSoundsListener);

        // Create a single Audio object (reused for all sounds)
        this.catSfx = new THREE.Audio(this.catSoundsListener);

        this.soundBuffers = [
            this.resourcesRef.objectsLoaded.catMeowSound1,
            this.resourcesRef.objectsLoaded.catMeowSound2,
            this.resourcesRef.objectsLoaded.catMeowSound3
        ];  
        
        //console.log("Cat sounds setup complete");
    }

    playRandomSFX() 
    {
        if (this.catSfx.isPlaying) return;
      
        const buffer = this.soundBuffers[Math.floor(Math.random() * this.soundBuffers.length)];
      
        this.catSfx.stop();
        this.catSfx.setBuffer(buffer);
        this.catSfx.setLoop(false);
        this.catSfx.setVolume(1.0);
        this.catSfx.play();
    }

}